__turbopack_context__.v({
  "divider": "SectionContainer-module-scss-module__0CBwZq__divider",
  "inverted": "SectionContainer-module-scss-module__0CBwZq__inverted",
  "padded": "SectionContainer-module-scss-module__0CBwZq__padded",
  "section__container": "SectionContainer-module-scss-module__0CBwZq__section__container",
  "section__content": "SectionContainer-module-scss-module__0CBwZq__section__content",
  "section__heading": "SectionContainer-module-scss-module__0CBwZq__section__heading",
  "ypadded": "SectionContainer-module-scss-module__0CBwZq__ypadded",
});
